var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect, _rect2, _rect3, _path33, _path34, _path35, _path36, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 31,
    viewBox: "0 0 195 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.233 10.4354C177.198 6.5069 179.736 3.98639 183.282 4.02985C186.828 3.98639 189.383 6.5069 189.34 10.4354C189.383 14.3639 186.828 16.8844 183.282 16.841C179.736 16.8844 177.198 14.3639 177.233 10.4354ZM183.195 14.7116H183.378C185.594 14.7116 186.932 13.095 186.932 10.4354C186.932 7.76715 185.594 6.16794 183.378 6.16794H183.195C180.979 6.16794 179.64 7.76715 179.64 10.4354C179.64 13.095 180.979 14.7116 183.195 14.7116Z",
    fill: "#14171F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.762 16.6672V4.20371H171.55C173.636 4.17763 175.418 5.67255 175.374 7.59335C175.374 9.18388 174.679 10.2095 173.254 10.7396C174.549 10.7396 175.192 11.3307 175.192 12.504V16.6672H172.793V13.1037C172.793 12.2085 172.532 11.9477 171.637 11.9477H168.161V16.6672H165.762ZM168.161 9.85312H170.838C172.237 9.85312 172.967 9.22734 172.967 8.054C172.967 6.90673 172.263 6.34179 170.838 6.34179H168.161V9.85312Z",
    fill: "#14171F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.148 16.6676V4.2041H159.754C162.179 4.2041 163.761 5.65557 163.761 8.12393C163.761 10.5923 162.179 12.0611 159.754 12.0611H156.547V16.6676H154.148ZM156.547 9.92305H159.485C160.702 9.92305 161.354 9.22773 161.354 8.12393C161.354 7.02012 160.702 6.34219 159.485 6.34219H156.547V9.92305Z",
    fill: "#14171F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.809 16.6672V4.20371H143.597C145.683 4.17763 147.465 5.67255 147.421 7.59335C147.421 9.18388 146.726 10.2095 145.301 10.7396C146.596 10.7396 147.239 11.3307 147.239 12.504V16.6672H144.84V13.1037C144.84 12.2085 144.579 11.9477 143.684 11.9477H140.207V16.6672H137.809ZM140.207 9.85312H142.884C144.284 9.85312 145.014 9.22734 145.014 8.054C145.014 6.90673 144.31 6.34179 142.884 6.34179H140.207V9.85312Z",
    fill: "#14171F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.469 10.4354C123.434 6.5069 125.972 3.98639 129.518 4.02985C133.064 3.98639 135.62 6.5069 135.576 10.4354C135.62 14.3639 133.064 16.8844 129.518 16.841C125.972 16.8844 123.434 14.3639 123.469 10.4354ZM129.431 14.7116H129.614C131.83 14.7116 133.169 13.095 133.169 10.4354C133.169 7.76715 131.83 6.16794 129.614 6.16794H129.431C127.215 6.16794 125.877 7.76715 125.877 10.4354C125.877 13.095 127.215 14.7116 129.431 14.7116Z",
    fill: "#14171F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.203 16.6676V6.34219H111.9V4.2041H122.938V6.34219H118.61V16.6676H116.203Z",
    fill: "#14171F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.176 12.4866H103.583C103.67 13.7643 104.609 14.7116 106.434 14.7116H106.608C107.912 14.7116 108.642 14.025 108.642 13.1993C108.642 12.4432 108.303 12.0434 107.234 11.8261L105.009 11.3654C102.827 10.9048 101.802 9.67062 101.802 7.7672C101.767 5.87247 103.575 3.99513 106.521 4.02989C109.476 4.00382 111.267 5.75948 111.24 8.12355H108.833C108.755 6.86329 107.842 6.16798 106.521 6.16798H106.338C105.043 6.16798 104.209 6.87198 104.209 7.68029C104.209 8.48859 104.644 8.87101 105.721 9.08829L107.59 9.46202C109.806 9.90528 111.041 11.0612 111.041 13.0168C111.067 15.1549 109.241 16.8671 106.252 16.841C102.897 16.841 101.28 15.1201 101.176 12.4866Z",
    fill: "#14171F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3535 16.6676V4.2041H99.7837V6.34219H92.7523V9.21035H98.7146V11.3484H92.7523V14.5295H99.9662V16.6676H90.3535Z",
    fill: "#14171F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1396 4.2041H88.773L84.1058 16.6676H80.9942L76.2227 4.2041H78.9083L82.6021 14.1471L86.1396 4.2041Z",
    fill: "#14171F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2928 4.2041H74.6916V16.6676H71.5801L66.6781 7.48945V16.6676H64.2793V4.2041H67.3908L72.2928 13.3388V4.2041Z",
    fill: "#14171F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9609 16.6676V4.2041H61.3598V16.6676H58.9609Z",
    fill: "#14171F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.324 24.165H157.066V30H155.963V25.4102L154.514 30H153.281L151.788 25.3939V30H150.689V24.165H152.439L153.904 28.7427L155.324 24.165Z",
    fill: "#A5B1C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.559 27.0821C143.542 25.2429 144.731 24.0629 146.391 24.0833C148.051 24.0629 149.247 25.2429 149.227 27.0821C149.247 28.9213 148.051 30.1013 146.391 30.081C144.731 30.1013 143.542 28.9213 143.559 27.0821ZM146.35 29.0841H146.436C147.473 29.0841 148.1 28.3272 148.1 27.0821C148.1 25.8329 147.473 25.0842 146.436 25.0842H146.35C145.313 25.0842 144.686 25.8329 144.686 27.0821C144.686 28.3272 145.313 29.0841 146.35 29.0841Z",
    fill: "#A5B1C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.227 27.0821C137.214 25.2917 138.26 24.0669 140.018 24.0832C141.511 24.0669 142.398 24.9703 142.468 26.0811H141.345C141.218 25.4463 140.763 25.0842 140.059 25.0842H139.977C139.021 25.072 138.342 25.8532 138.354 27.0821C138.354 28.315 139.013 29.084 139.977 29.084H140.059C140.771 29.084 141.218 28.7341 141.345 28.0831H142.468C142.394 29.2387 141.519 30.0932 140.018 30.0809C138.26 30.0972 137.214 28.8724 137.227 27.0821Z",
    fill: "#A5B1C0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.893 29.9996V28.7911H136.101V29.9996H134.893Z",
    fill: "#A5B1C0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.948 30H132.621L131.262 27.9533L129.879 30H128.613L130.632 27.0093L128.739 24.165H130.062L131.299 26.0246L132.556 24.165H133.822L131.93 26.9686L133.948 30Z",
    fill: "#A5B1C0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.363 30V24.165H127.778V25.166H124.486V26.5088H127.278V27.5098H124.486V28.999H127.864V30H123.363Z",
    fill: "#A5B1C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.233 27.0821C116.216 25.2429 117.404 24.0629 119.065 24.0833C120.725 24.0629 121.921 25.2429 121.901 27.0821C121.921 28.9213 120.725 30.1013 119.065 30.081C117.404 30.1013 116.216 28.9213 116.233 27.0821ZM119.024 29.0841H119.109C120.147 29.0841 120.774 28.3272 120.774 27.0821C120.774 25.8329 120.147 25.0842 119.109 25.0842H119.024C117.986 25.0842 117.36 25.8329 117.36 27.0821C117.36 28.3272 117.986 29.0841 119.024 29.0841Z",
    fill: "#A5B1C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.029 24.165H114.771V30H113.668V25.4102L112.219 30H110.986L109.493 25.3939V30H108.395V24.165H110.144L111.609 28.7427L113.029 24.165Z",
    fill: "#A5B1C0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.564 29.9996V28.7911H106.773V29.9996H105.564Z",
    fill: "#A5B1C0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.635 30V24.165H103.259C104.395 24.165 105.135 24.8446 105.135 26.0002C105.135 27.1558 104.395 27.8434 103.259 27.8434H101.758V30H100.635ZM101.758 26.8424H103.133C103.703 26.8424 104.008 26.5169 104.008 26.0002C104.008 25.4834 103.703 25.166 103.133 25.166H101.758V26.8424Z",
    fill: "#A5B1C0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5041 27.0821C93.4878 25.2429 94.6759 24.0629 96.3361 24.0833C97.9963 24.0629 99.1925 25.2429 99.1722 27.0821C99.1925 28.9213 97.9963 30.1013 96.3361 30.081C94.6759 30.1013 93.4878 28.9213 93.5041 27.0821ZM96.2954 29.0841H96.3809C97.4185 29.0841 98.0451 28.3272 98.0451 27.0821C98.0451 25.8329 97.4185 25.0842 96.3809 25.0842H96.2954C95.2578 25.0842 94.6312 25.8329 94.6312 27.0821C94.6312 28.3272 95.2578 29.0841 96.2954 29.0841Z",
    fill: "#A5B1C0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.252 30V24.165H88.375V26.582H90.9181V24.165H92.0452V30H90.9181V27.583H88.375V30H87.252Z",
    fill: "#A5B1C0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1113 28.0424H82.2384C82.2791 28.6405 82.7186 29.084 83.5731 29.084H83.6545C84.2648 29.084 84.6066 28.7626 84.6066 28.376C84.6066 28.022 84.4479 27.8349 83.9474 27.7331L82.9058 27.5175C81.8844 27.3018 81.4043 26.724 81.4043 25.8329C81.388 24.9459 82.2344 24.067 83.6138 24.0832C84.9972 24.071 85.8354 24.893 85.8232 25.9997H84.6961C84.6595 25.4097 84.2323 25.0842 83.6138 25.0842H83.5283C82.922 25.0842 82.5314 25.4138 82.5314 25.7922C82.5314 26.1706 82.7349 26.3497 83.2394 26.4514L84.1143 26.6264C85.1519 26.8339 85.7297 27.3751 85.7297 28.2906C85.7419 29.2916 84.8874 30.0932 83.4876 30.081C81.917 30.081 81.1602 29.2753 81.1113 28.0424Z",
    fill: "#A5B1C0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3104 30L78.7855 28.6247H76.3359L75.811 30H74.627L76.9341 24.165H78.2524L80.5026 30H79.3104ZM76.7144 27.6237H78.403L77.5566 25.4102L76.7144 27.6237Z",
    fill: "#A5B1C0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5825 30V25.166H69.5684V24.165H74.736V25.166H72.7096V30H71.5825Z",
    fill: "#A5B1C0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.451 30L67.9261 28.6247H65.4766L64.9517 30H63.7676L66.0747 24.165H67.3931L69.6432 30H68.451ZM65.855 27.6237H67.5436L66.6973 25.4102L65.855 27.6237Z",
    fill: "#A5B1C0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1836 30V24.1651H60.1815C61.9434 24.1569 63.1519 25.2027 63.1396 27.0826C63.1519 28.9665 61.98 30.0123 60.2262 30H58.1836ZM59.3066 28.9991H60.1001C60.7064 28.9991 61.1784 28.8526 61.512 28.5596C61.8498 28.2666 62.0166 27.7743 62.0166 27.0826C62.0166 26.3949 61.8498 25.9026 61.512 25.6096C61.1784 25.3125 60.7064 25.1661 60.1001 25.1661H59.3066V28.9991Z",
    fill: "#A5B1C0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 10.8954 0.895431 10 2 10H10V20H0V12Z",
    fill: "url(#paint0_linear_396_11281)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 20H10V30H2C0.89543 30 0 29.1046 0 28V20Z",
    fill: "url(#paint1_linear_396_11281)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M20 12C20 10.8954 19.1046 10 18 10H10V20H20V12Z",
    fill: "url(#paint2_linear_396_11281)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20 20H10V30H18C19.1046 30 20 29.1046 20 28V20Z",
    fill: "url(#paint3_linear_396_11281)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 30,
    height: 30,
    rx: 2,
    fill: "url(#paint4_linear_396_11281)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 30,
    height: 30,
    rx: 2,
    fill: "url(#paint5_linear_396_11281)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 30,
    height: 30,
    rx: 2,
    fill: "url(#paint6_linear_396_11281)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.584 22.4997L23.334 21.2497L34.584 9.99967C34.7374 9.84627 34.5573 9.59636 34.3632 9.69339L34.0186 9.86571C33.8424 9.95381 33.6481 9.99967 33.4511 9.99967H25.0007V8.33301H37.5007V20.833H35.834V12.3826C35.834 12.1856 35.8798 11.9913 35.9679 11.8151L36.1403 11.4704C36.2373 11.2764 35.9874 11.0963 35.834 11.2497L24.584 22.4997Z",
    fill: "url(#paint7_linear_396_11281)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.584 22.4997L23.334 21.2497L34.584 9.99967C34.7374 9.84627 34.5573 9.59636 34.3632 9.69339L34.0186 9.86571C33.8424 9.95381 33.6481 9.99967 33.4511 9.99967H25.0007V8.33301H37.5007V20.833H35.834V12.3826C35.834 12.1856 35.8798 11.9913 35.9679 11.8151L36.1403 11.4704C36.2373 11.2764 35.9874 11.0963 35.834 11.2497L24.584 22.4997Z",
    fill: "url(#paint8_linear_396_11281)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 30H18C19.1046 30 20 29.1046 20 28V12C20 10.8954 19.1046 10 18 10H15V28C15 29.1046 15.8954 30 17 30Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 30H18C19.1046 30 20 29.1046 20 28V12C20 10.8954 19.1046 10 18 10H15V28C15 29.1046 15.8954 30 17 30Z",
    fill: "url(#paint9_linear_396_11281)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_11281",
    x1: 5,
    y1: 10,
    x2: 5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_11281",
    x1: 5,
    y1: 10,
    x2: 5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_11281",
    x1: 15,
    y1: 10,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_11281",
    x1: 15,
    y1: 10,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_11281",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_11281",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_396_11281",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565E67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_396_11281",
    x1: 30.4173,
    y1: 8.33301,
    x2: 30.4173,
    y2: 22.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_396_11281",
    x1: 30.4173,
    y1: 11.3298,
    x2: 30.4173,
    y2: 21.1375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_396_11281",
    x1: 30,
    y1: 10,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorProLogo);
export default __webpack_public_path__ + "static/media/InvestorProLogo.7d5ab4e91673c5f035bf1d7219f97161.svg";
export { ForwardRef as ReactComponent };